
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { IOnOffHandlers } from 'bonomo';
import { IErrors } from '@/model/IErrors';

const userModule = namespace('userModule');

@Component({ name: 'UserDeleteDialog' })
export default class UserDeleteDialog extends Vue {
  @Prop()
  protected userId!: number;

  @userModule.Getter('errors')
  protected errors!: IErrors;

  private showing: boolean = false;
  private disabled: boolean = false;
  private confirmText: string = '';
  private subscribes: IOnOffHandlers = {};

  private readonly validConfirmations = ['delete', 'borrar', 'esborra'];

  get isConfirmValid(): boolean {
    return this.validConfirmations.includes(this.confirmText.toLowerCase());
  }

  created() {
    this.subscribes = this.$ons({
      'user-delete-dialog.show': this.onShow,
      'backend.call.begin.userDeleted': () => { this.disabled = true; },
      'backend.call.OK.userDeleted': this.onDeleted,
      'backend.call.KO.userDeleted': () => { this.disabled = false; },
    });
  }

  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  private onShow() {
    this.confirmText = '';
    this.disabled = false;
    this.showing = true;
  }

  private onCancel() {
    this.showing = false;
  }

  private onSubmit() {
    if (!this.isConfirmValid) return;
    this.$store.dispatch('userModule/deleteUser', {
      userId: this.userId,
      confirm: this.confirmText,
    });
  }

  private onDeleted() {
    this.showing = false;
    this.$router.push({ name: 'userList' });
  }
}
